function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHourglasslow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.091V3.75a1.502 1.502 0 00-1.5-1.5H6.75a1.502 1.502 0 00-1.5 1.5v3.375a1.507 1.507 0 00.6 1.2L10.75 12l-4.9 3.675a1.506 1.506 0 00-.595 1.118.744.744 0 00-.005.082v3.375a1.502 1.502 0 001.5 1.5h10.5a1.502 1.502 0 001.5-1.5v-3.341a1.508 1.508 0 00-.596-1.197L13.244 12l4.91-3.712a1.508 1.508 0 00.596-1.197zM7.743 16.13l4.255-3.191 4.253 3.215-8.508-.024zM17.25 7.09l-5.252 3.97L6.75 7.125V3.75h10.5v3.341z",
    fill: props.fill
  }));
}

export default SvgHourglasslow;